import React from 'react';
import styled from 'styled-components';
import theme from '@williamhill/rosi-ui-shared/src/themes';
import { IIcon } from '.';

const SVG = ({
  background,
  width = '18',
  height = '23',
  fill,
  className = 'icon',
  viewBox = '0 0 18 23',
  strokeWidth = '1.5'
}: IIcon) => (
  <Circle background={background} height={height} width={height}>
    <svg width={width} height={height} viewBox={viewBox} version="1.1" className={`svg-icon ${className}`}>
      <title>{`${className}`}</title>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="POS-User-Locks-outline"
          transform="translate(-33.000000, -255.000000)"
          fillRule="nonzero"
          fill={fill}
          stroke={theme.colors.brand.primary}
          strokeWidth={strokeWidth}>
          <path
            d="M48,263.875 L47.3333333,263.875 L47.3333333,261.25 C47.3333333,258.354553 44.9414062,256 42,256 C39.0585938,256 36.6666667,258.354553 36.6666667,261.25 L36.6666667,263.875 L36,263.875 C34.8977865,263.875 34,264.757797 34,265.84375 L34,275.03125 C34,276.117203 34.8977865,277 36,277 L48,277 C49.1022135,277 50,276.117203 50,275.03125 L50,265.84375 C50,264.757797 49.1022135,263.875 48,263.875 Z M39,261.428549 C39,259.537628 40.3454337,258 42,258 C43.6545663,258 45,259.537628 45,261.428549 L45,264 L39,264 L39,261.428549 Z"
            id="Shape"></path>
        </g>
      </g>
    </svg>
  </Circle>
);

const Circle = styled.div<{ background?: string; height?: string; width?: string }>`
  background-color: ${({ background }) => `${background}`};
  border-radius: 14px;
  display: inline-block;
  height: 28px;
  padding: 2px 0 0 5px;
  width: 28px;
`;

export default SVG;
